<script setup lang="ts">
import type { CollectionTrimmed } from "~/common/interfaces/collection-trimmed";
import { useQueryValueIdMapping } from "~/composables/use-query-value-id-mapping";

defineProps({
	collections: {
		type: Array as PropType<CollectionTrimmed[]>,
		default () {
			return [];
		}
	}
});

const { ids, switchQueryId } = useQueryValueIdMapping("collections");
</script>

<template>
	<ul class="pt-3 flex flex-wrap gap-3 max-w-[256px]">
		<li v-for="{id, name} in collections" :key="id">
			<CommonCheckboxTag
				:model-value="ids.includes(id)"
				@update:model-value="switchQueryId(id)"
			>
				{{ name }}
			</CommonCheckboxTag>
		</li>
	</ul>
</template>
